import { Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { JWTService } from './jwt.service';

@Injectable()
export class SessionService {
  
  @Output() onSessionExpire = new BehaviorSubject<boolean>(false);
  @Output() onSuccessfullCallToApi = new BehaviorSubject<boolean>(false);
  readonly sesionLengthInMin = environment.common.sessionTimeoutInMin;
  timeStamp: Date;
  timer = null;
  isActive = false;
  logInterval = null;
  apiUri: string = environment.apiUri + "/TofesMashkanta";

  constructor(
    private jwtService:JWTService,
    private router: Router,
    ) { 

      this.startSession();

      this.onSuccessfullCallToApi.subscribe(isSuc => {
        this.extendSession();
      });

      this.onSessionExpire.subscribe(isDisconnect => {
        if (isDisconnect) {
          // alert("נותקת מהמערכת");
          this.logout();
        }
      });

      this.setDebug();
  }

  logout() {
    //session modal...
    //true: call isAlive , false: navigate login
    //settimeout after 30 sec no call navigate login

    this.stopSession();
    this.jwtService.clearJwt();

    this.router.navigate(["/"]);
  }

  startSession() {
    this.isActive = true;
    console.log("%csession start", "font-size: 24px",`${this.sesionLengthInMin}min`);
    this.jwtService.clearJwt();
    this.extendSession();
  }

  stopSession() {
    this.isActive = false;
    console.log("%csession stop", "font-size: 24px");

    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  extendSession() { 
    this.timeStamp = new Date();

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    if(this.isSessionExpire()){
      if (this.isActive) {
        console.log("session expires: 0");

        this.logout();
      }
    } else if (this.isActive) {
      this.timer = setTimeout(r => {
        console.log("session expires");

        if (this.isActive) {
          this.logout();
        }
      }, this.sesionLengthInMin * 60 * 1000);

      console.log("session extended");
    }
  }

  isSessionExpire() {
    let now = new Date();

    let timePassInMin = (now.getTime() - this.timeStamp.getTime()) / 1000 / 60;

    return this.sesionLengthInMin < timePassInMin
  }

  //DEBUG
  sessionRemain() {
    let now = new Date();

    const timePassSec = (now.getTime() - this.timeStamp.getTime()) / 1000;
    const timeRemain = this.sesionLengthInMin * 60 - timePassSec;

    const rh = Math.floor(timeRemain / 60 / 60);
    const rm = Math.floor(timeRemain / 60 % 60);
    const rs = Math.floor((timeRemain % 60) % 60);

    return `${rh}:${rm}:${rs}`;
  }

  showCoutDown() {
    if (this.logInterval) {
      clearInterval(this.logInterval);
      this.logInterval = null;
    }

    // if (this.isActive) {
    this.logInterval = setInterval(r => {
      if (this.isActive) {
        console.debug(`*** session remain: , ${this.sessionRemain()}`);
      }
    }, 20000)
    // }
  }

  setDebug() {
    this.showCoutDown();
    // window["showCoutDown"] = this.showCoutDown;
    // window["sessionRemain"] = this.sessionRemain;
  }
  //END DEBUG

  
}



// WEBPACK FOOTER //
// ./src/app/services/session.service.ts